import * as Sentry from '@sentry/react'

/**
 * Log error to Sentry
 *
 * Note: development environment, it will log error in console
 * @param {Error} error - Error object
 */
export const logErrorAsync = async (error) => {
  try {
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error)
    } else {
      console.error(error)
    }
  } catch (error) {
    console.error(error)
  }
}

export const to = async (promise) => {
  try {
    const result = await promise
    return [null, result]
  } catch (error) {
    return [error, null]
  }
}
